import React, { Component } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import formatDate from 'dateformat'

import classNames from './ExternalShares.css'
import { fetchExternalShares, deleteExternalShare, setExternalShareDuration } from '../redux/share'
import LoadingSpinner from '../components/LoadingSpinner'
import ErrorMessage from '../components/ErrorMessage'
import EmptyNotice from '../components/EmptyNotice'
import { pluralize } from '../utils/string'
import { userHasPerm } from '../utils/auth'

class ExternalShares extends Component {
  state = {
    selectedCode: 'your_code_here',
    sortBy: 'external_id',
    sortDesc: false
  }
  componentDidMount () {
    this.props.fetchExternalShares()
  }
  getName = id => {
    const { entities } = this.props
    if (entities.users[id]) {
      return entities.users[id].name
    }
    return 'Unknown'
  }
  sortShares = (a, b) => {
    const { sortBy, sortDesc } = this.state
    let compareA = sortBy === 'duration' ? getShareTimeLeft(a) : a[sortBy]
    let compareB = sortBy === 'duration' ? getShareTimeLeft(b) : b[sortBy]
    if (sortDesc) {
      return compareA > compareB ? -1 : 1
    }
    return compareA > compareB ? 1 : -1
  }
  renderShare = share => {
    const creationDate = new Date(share.created_at)
    const timeLeft = getShareTimeLeft(share)
    const onClickDelete = () => this.props.deleteExternalShare(share.external_id)
    const onClickExtend = () => extendShare(share, timeLeft, this.props.setExternalShareDuration)
    const onClickSuspend = () => this.props.setExternalShareDuration(share.external_id, null)
    return (
      <tr key={share.external_id}>
        <td>
          <button onClick={() => this.setState({ selectedCode: share.external_id })}>
            {share.external_id}
          </button>
        </td>
        <td>
          <Link to={share.path}>
            {share.path}
          </Link>
        </td>
        {this.props.isAdmin &&
          <td>{this.getName(share.user_id)}</td>
        }
        <td>{formatDate(creationDate, 'HH:MM, d mmm yyyy')}</td>
        <td>{getShareDaysLeft(timeLeft)}</td>
        <td>
          {this.props.canExtend &&
            <button onClick={onClickExtend} className={classNames.button}>
              {timeLeft === Infinity ? 'Reset' : 'Extend'}
            </button>
          }
          {this.props.canSuspend &&
            <button onClick={onClickSuspend} className={classNames.button} disabled={timeLeft === Infinity}>
              Suspend
            </button>
          }
          <button onClick={onClickDelete} className={classNames.deleteButton}>
            Delete
          </button>
        </td>
      </tr>
    )
  }
  render () {
    const { data, fetching, error, fetchExternalShares } = this.props

    if (error) {
      return (
        <ErrorMessage
          message='There was an error fetching external share codes'
          onRetry={fetchExternalShares}
        />
      )
    }

    if (!data || fetching) {
      return <LoadingSpinner />
    }

    if (data.length === 0) {
      return (
        <div className={classNames.page}>
          <EmptyNotice
            heading='You have no external shares'
            text='Anything you share externally will appear here.'
          />
        </div>
      )
    }

    const { protocol, host } = window.location

    const setSort = value => () => this.setState({
      sortBy: value,
      sortDesc: this.state.sortBy === value && !this.state.sortDesc
    })

    return (
      <div className={classNames.page}>
        <table className={classNames.table}>
          <tbody>
            <tr>
              <th onClick={setSort('external_id')}>Code</th>
              <th onClick={setSort('path')}>Path</th>
              {this.props.isAdmin &&
                <th onClick={setSort('user_id')}>Created By</th>
              }
              <th onClick={setSort('created_at')}>Created</th>
              <th onClick={setSort('duration')}>Expires</th>
              <th />
            </tr>
            {data.sort(this.sortShares).map(this.renderShare)}
          </tbody>
        </table>
        <label>
          Click a code to display the full link below
          <input
            type='text'
            className={classNames.code}
            value={`${protocol}//${host}/share/${this.state.selectedCode}`}
            onClick={e => e.target.setSelectionRange(0, 9999)}
            readOnly
          />
        </label>
      </div>
    )
  }
}

export function getShareTimeLeft (share) {
  if (!share.duration) {
    return Infinity
  }
  const creationDate = new Date(share.created_at)
  const expiryDate = new Date(creationDate.getTime() + (share.duration * 1000))
  return Math.max(0, expiryDate - new Date())
}

export function getShareDaysLeft (timeLeft) {
  if (timeLeft === Infinity) {
    return 'Never'
  }
  const days = Math.round(timeLeft / (1000 * 60 * 60 * 24))
  if (days > 0) {
    return pluralize(Math.max(1, days), 'day')
  }
  return 'Expired'
}

// TODO: should probably be in redux action
export function extendShare (share, timeLeft, setExternalShareDuration) {
  // Add one week to duration
  let newDuration = share.duration + 604800
  if (!timeLeft || timeLeft === Infinity) {
    // Share is expired
    // Calculate new duration so that expiry is one week from now
    const secondsDifference = Math.round((new Date().getTime() - new Date(share.created_at)) / 1000)
    newDuration = secondsDifference + 604800
  }
  setExternalShareDuration(share.external_id, newDuration)
}

const mapStateToProps = ({ auth, share, users, entities }) => ({
  data: share.external.data,
  fetching: share.external.fetching,
  error: share.external.error,
  entities,
  isAdmin: userHasPerm(auth.user, 'admin'),
  canExtend: userHasPerm(auth.user, 'extend_external_share') || userHasPerm(auth.user, 'admin'),
  canSuspend: userHasPerm(auth.user, 'admin')
})

const mapDispatchToProps = {
  fetchExternalShares,
  deleteExternalShare,
  setExternalShareDuration
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalShares)



// WEBPACK FOOTER //
// ./src/pages/ExternalShares.js